import { useTranslation } from 'react-i18next';
import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { setTag, setUser, withProfiler } from '@sentry/react';
import app from '@/utils/app';
import { inboxUser } from '@/state/inboxAuth';

const SentryProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { i18n } = useTranslation();
  const user = useAtomValue(inboxUser);

  useEffect(() => {
    setTag('idk.lang', i18n.language);
  }, [i18n]);

  useEffect(() => {
    setTag('idk.env', app.env);
  }, []);

  useEffect(() => {
    if (user) {
      setUser({ username: 'InboxUser()' });
    } else {
      setUser(null);
    }
  }, [user]);

  return <>{children}</>;
};

export default withProfiler(SentryProvider);
